import React from 'react';

const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg shadow-lg overflow-hidden ${className}`}>
    {children}
  </div>
);

const ToolsAndTechnologies = () => {
  const technicalInfrastructure = [
    { category: "Serveurs", tools: ["Dell PowerEdge R740 (dernière génération)", "HPE ProLiant DL380 Gen10"] },
    { category: "Virtualisation", tools: ["VMware vSphere 7.0", "Proxmox VE 7.1"] },
    { category: "Stockage", tools: ["NetApp AFF A400 (All-Flash)", "Dell EMC Unity XT 480F"] },
    { category: "Réseau", tools: ["Cisco Nexus 9300 (Data Center)", "Palo Alto Networks PA-5250 (Firewall)"] },
    { category: "Sauvegarde", tools: ["Veeam Backup & Replication v11", "Rubrik CDM 6.0"] }
  ];

  const developmentTools = [
    { category: "IDE", tools: ["IntelliJ IDEA 2023.1", "Visual Studio Code 1.77"] },
    { category: "Langages", tools: ["Java 17 LTS", "Python 3.10", "TypeScript 4.9"] },
    { category: "Frameworks Backend", tools: ["Spring Boot 2.7", "Django 4.1", "Express.js 4.18"] },
    { category: "Frameworks Frontend", tools: ["React 18.2", "Angular 15", "Vue.js 3.2"] },
    { category: "Base de données", tools: ["PostgreSQL 14", "MongoDB 5.0", "Redis 6.2"] },
    { category: "ORM", tools: ["Hibernate 5.6", "Sequelize 6.3", "Mongoose 6.3"] },
    { category: "Tests", tools: ["JUnit 5.8", "Jest 29", "Selenium 4.1"] }
  ];

  const projectManagementTools = [
    { category: "Gestion de projet", tools: ["Jira Software 9.4 (Server)", "Redmine 5.0"] },
    { category: "Collaboration", tools: ["Mattermost 7.8 (Team Edition)", "Rocket.Chat 5.0"] },
    { category: "Versionning", tools: ["GitLab 15.10 (Self-Managed)", "Bitbucket Server 7.21"] },
    { category: "CI/CD", tools: ["Jenkins 2.387", "GitLab CI/CD (intégré à GitLab)"] },
    { category: "Documentation", tools: ["Confluence 7.19 (Server)", "BookStack 22.11"] },
    { category: "Monitoring", tools: ["Prometheus 2.42", "Grafana 9.4", "ELK Stack 8.6"] }
  ];

  const renderToolSection = (items) => (
    items.map((item, index) => (
      <div key={index} className="mb-4">
        <h4 className="text-sm font-semibold text-blue-600 mb-2">{item.category}</h4>
        <ul className="space-y-1">
          {item.tools.map((tool, idx) => (
            <li key={idx} className="flex items-start text-xs text-gray-600">
              <span className="text-blue-500 mr-2">•</span>
              {tool}
            </li>
          ))}
        </ul>
      </div>
    ))
  );

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <Card>
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6">
          <h2 className="text-2xl font-bold text-center text-white">
            Infrastructure et Outils de Développement
          </h2>
        </div>
        
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-xl font-semibold mb-4">Infrastructure Technique (On-Premise)</h3>
              <div className="bg-gray-50 p-4 rounded-lg shadow-sm border border-blue-200">
                {renderToolSection(technicalInfrastructure)}
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Outils de Développement</h3>
              <div className="bg-gray-50 p-4 rounded-lg shadow-sm border border-blue-200 max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                {renderToolSection(developmentTools)}
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Outils de Gestion de Projet et DevOps</h3>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm border border-blue-200">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {renderToolSection(projectManagementTools)}
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="text-lg font-semibold text-blue-700 mb-3">Notre Approche Technologique</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div className="flex items-start text-sm text-gray-700">
                <span className="text-blue-500 mr-2">•</span>
                Infrastructure on-premise robuste et sécurisée
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <span className="text-blue-500 mr-2">•</span>
                Stack technologique moderne avec versions LTS privilégiées
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <span className="text-blue-500 mr-2">•</span>
                Outils open-source et enterprise adaptés aux besoins spécifiques
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <span className="text-blue-500 mr-2">•</span>
                Mise à jour régulière et gestion des versions maîtrisée
              </div>
              <div className="flex items-start text-sm text-gray-700">
                <span className="text-blue-500 mr-2">•</span>
                Possibilité d'adaptation aux environnements clients existants
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ToolsAndTechnologies;